import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/service/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../loginone/login.service';
import { UserLogin } from 'app/shared/models/user-login.model';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { ValidateService } from 'app/shared/validate.service';
import { GlobalService } from 'app/shared/global.service';
import { DatePipe } from '@angular/common';
import { MiscService } from 'app/shared/misc.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SetRights } from 'app/shared/set-rights';
import { PickDateAdapter, PICK_FORMATS } from "app/shared/format-datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { BookingService } from '../booking/booking.service';
import { PaymentGatewayService } from '../booking-login/payment-gateway.service';
import { BookingLoginService } from '../booking-login/booking-login.service';
import { CommonService } from 'app/shared/common.service';

declare var Razorpay: any;

@Component({
  selector: 'app-donate',
  templateUrl: './donate.component.html',
  styleUrls: ['./donate.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ],
})
export class DonateComponent implements OnInit {
  page = 1;
  filters: string = '';
  messages = {};
  public currentDate = new Date();
  datePipe = new DatePipe("en-US");
  Today = '';
  Prefix = [];
  LanguageType = [];
  States = [];
  City = [];
  District = [];

  constructor(
    private pageTitleService: PageTitleService,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private paymentGatewayService: PaymentGatewayService,
    private toasterService: ToastrService,
    public translate: TranslateService,
    public validateService: ValidateService,
    public globals: GlobalService,
    private miscService: MiscService,
    public bookingService: BookingService,
    public bookingLoginService: BookingLoginService,
    private modalService: NgbModal,
    private commonService: CommonService,
  ) { }

  genders = [
    { value: 'MALE', description: 'MALE' },
    { value: 'FEMALE', description: 'FEMALE' },
    { value: 'TRANSGENDER', description: 'TRANSGENDER' }
  ];

  Nationality = [
    { id: 1, value: 'Indian', description: 'Indian' },
    { id: 2, value: 'America', description: 'America' },
    { id: 3, value: 'Japan', description: 'Japan' }
  ];

  trackByFn(index: number, item: any): any {
    return index; // Or return a unique identifier of the item
  }

  ngOnInit(): void {
    this.globals.LastVisitedComponent = this.router.url;
    if (this.globals.UserName == '') {
      this.router.navigate(['/session/booking-login/booking-login-register']);
    }
    this.miscService.getMiscellaneous('Prefix').subscribe(data => {
      this.Prefix = data as string[];
    });
    this.miscService.getMiscellaneous('LanguageType').subscribe(data => {
      this.LanguageType = data as string[];
    });
    this.Today = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.LoadGuest();
    this.getStateList();
    this.GetConfigurationDetails();
  }

  CountryandNationality = [];
  // Get Country and Nationalty list from mstcountry
  GetCountryandNationality() {
    this.bookingLoginService.GetCountryandNationality().subscribe(data => {
      this.CountryandNationality = data;
    });
  }

  //Getting State List
  getStateList() {
    this.commonService.GetStateList('State', '').subscribe(
      (data: any) => {
        this.States = data;
      }
    );
  }

  //Getting District List
  GetDistrictList(event) {
    let State = event.source.value;
    this.commonService.GetStateList('District', State).subscribe(
      (data: any) => {
        this.District = data;
      }
    );

  }

  //Getting City List
  GetCityList(event, param) {
    let State = param == 'Guest' ? this.itemToEdit.State : event.source.value;
    this.commonService.GetStateList('City', State).subscribe(
      (data: any) => {
        this.City = [];
        this.City = data;
      }
    );
  }

  advanceReceiptBook = 0;
  donationReceiptBook = 0;
  configurationDetaild = [];

  // Get configuration Details From mstclientconfiguration
  GetConfigurationDetails() {
    this.loginService.GetConfigurationDetails().subscribe(data => {
      this.configurationDetaild = data;
      this.CarmeApplication_ClientID = this.configurationDetaild[0]["Application_ClientID"];
      this.CarmeApplication_ClientSecret = this.configurationDetaild[0]["Application_ClientSecret"];

      const paymentReceiptBook = this.configurationDetaild[0]["PaymentReceiptBook"] != undefined
        && this.configurationDetaild[0]["PaymentReceiptBook"] != "" ? this.configurationDetaild[0]["PaymentReceiptBook"].split(",") : "";
      if (paymentReceiptBook.length > 0) {
        this.advanceReceiptBook = +paymentReceiptBook[0];
        this.donationReceiptBook = +paymentReceiptBook[1];
      }

      this.GetPaymentGatewayDetails();

    });
  }

  PaymentVerificationRequest = {
    'ThirdpartyPaymentID': '',
    'ThirdpartyPaymentOrderID': '',
    'razorpay_signature': '',
    'ClientSecret': ''
  };

  CarmePaymentGateway_key = "";
  CarmePaymentGateway_secret = "";
  CarmeApplication_ClientID = "";
  CarmeApplication_ClientSecret = "";
  ClientPublic_Token = "";
  ClientAccess_Token = "";
  ClientRefresh_Token = "";
  ClientExpires_In = 0;
  ClientPaymentGatewayTypeID = 0;
  ClientState = "";
  PaymentGateway = 0;
  paymentGatewaydetails = [];

  ThirdpartyPaymentID = "";
  ThirdpartyPaymentOrderID = "";


  // Getting Payment Gateway Details by ClientID and LocationID
  GetPaymentGatewayDetails() {
    this.PaymentGateway = 1;
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.PaymentGateway != 0) {
        this.paymentGatewayService.GetPaymentGatewayDetails(2, 2, this.PaymentGateway).subscribe(data => {
          this.paymentGatewaydetails = data as string[];
          if (this.paymentGatewaydetails.length > 0) {

            // for website
            this.ClientPaymentGatewayTypeID = this.paymentGatewaydetails[0]["PaymentGatewayTypeID"];
            this.ClientExpires_In = this.paymentGatewaydetails[0]["Expires_In"];
            this.ClientPublic_Token = this.paymentGatewaydetails[0]["Public_Token"];
            this.ClientAccess_Token = this.paymentGatewaydetails[0]["Access_Token"];
            this.ClientRefresh_Token = this.paymentGatewaydetails[0]["Refresh_Token"];
            this.ClientState = this.paymentGatewaydetails[0]["State"];

          } else {
            this.CarmePaymentGateway_key = "";
            this.CarmePaymentGateway_secret = "";
            this.CarmeApplication_ClientID = "";
            this.CarmeApplication_ClientSecret = "";
            this.ClientPublic_Token = "";
            this.ClientAccess_Token = "";
            this.ClientRefresh_Token = "";
            this.ClientExpires_In = 0;
            this.ClientPaymentGatewayTypeID = 0;
            this.ClientState = "";
          }
        });
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetPaymentGatewayDetails();
    }

  }

  // getting razorpay refresh token
  GetRazorpayRefreshToken() {
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      this.paymentGatewayService.GetRazorpayRefreshToken(this.CarmeApplication_ClientID, this.CarmeApplication_ClientSecret, this.ClientRefresh_Token, this.ClientPaymentGatewayTypeID, this.globals.ClientID, this.globals.LocationID).subscribe((data: any) => {
        if (data == "OK") {
          this.GetPaymentGatewayDetails();
        }
      });
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetRazorpayRefreshToken();
    }

  }

  isTokenExpired(expiresIn: number): boolean {
    const currentTime = new Date().getTime();
    const expirationTime = currentTime + expiresIn * 1000;
    return expirationTime < currentTime; // Returns true if expired
  }

  GetRazorpay() {

    this.PaymentVerificationRequest = {
      'ThirdpartyPaymentID': '',
      'ThirdpartyPaymentOrderID': '',
      'razorpay_signature': '',
      'ClientSecret': ''
    };

    this.ThirdpartyPaymentID = "";
    this.ThirdpartyPaymentOrderID = "";

    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (!this.isTokenExpired(this.ClientExpires_In)) {
        if (this.DonationAmount != 0 && this.ClientAccess_Token != "") {
          this.paymentGatewayService.createOrder(this.DonationAmount, this.CarmePaymentGateway_key, this.CarmePaymentGateway_secret, this.ClientAccess_Token).subscribe((order: any) => {
            if (order.id != null && order.id != "") {
              const RozarpayOptions = {
                amount: 100 * 100,
                currency: 'INR',
                name: 'Nisargopchar Ashram',
                key: this.ClientPublic_Token,
                order_id: order.id,
                description: 'Donation Payment',
                prefill: {
                  name: this.GuestName,
                  email: this.globals.UserName,
                  contact: this.MobileNo,
                },
                theme: { color: '#6466e3' },
                handler: (response: any) => {
                  this.itemToEditPayment.ThirdpartyPaymentID = response.razorpay_payment_id;
                  this.itemToEditPayment.ThirdpartyPaymentOrderID = response.razorpay_order_id;


                  this.PaymentVerificationRequest.ThirdpartyPaymentID = response.razorpay_payment_id;
                  this.PaymentVerificationRequest.ThirdpartyPaymentOrderID = response.razorpay_order_id;
                  this.PaymentVerificationRequest.razorpay_signature = response.razorpay_signature;
                  this.PaymentVerificationRequest.ClientSecret = this.CarmeApplication_ClientSecret;

                  // Verify Payment Signature using ThirdpartyPaymentID, ThirdpartyPaymentOrderID
                  this.VerifyPaymentSignature();
                },
                modal: {
                  ondismiss: () => {
                  }
                }
              };
              // ? Open Razorpay Checkout on Billing Staff Monitor (Left)
              const rzp = new Razorpay(RozarpayOptions);
              rzp.open(); // Opens checkout for billing staff
            }
          });
        } else {
          this.toasterService.warning("Something went wrong");
        }
      } else {
        this.GetRazorpayRefreshToken();
        this.GetRazorpay();
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetRazorpay();
    }
  }

  // Razorpay Verify Payment Signature
  VerifyPaymentSignature() {
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.PaymentVerificationRequest.ThirdpartyPaymentID != "" && this.PaymentVerificationRequest.ThirdpartyPaymentOrderID != ""
        && this.PaymentVerificationRequest.razorpay_signature != "" && this.PaymentVerificationRequest.ClientSecret != "") {
        this.paymentGatewayService.VerifyPaymentSignature(this.PaymentVerificationRequest).subscribe((data) => {
          if (data != undefined && data != null) {
            if (data == 'OK') {
              this.SaveDonation(true);
            }
            else {
              this.globals.ShowToastrMessage("error", this.messages["msg_Exception"]);
            }
          }

        });
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.VerifyPaymentSignature();
    }
  }

  itemToEditPayment = {
    'Type': "Donation",
    'PaymentID': 0,
    'ReceiptBookID': 0,
    'ReceiptNo': 0,
    'BookingID': 0,
    'DonationID': 0,
    'Amount': 0,
    'RefundID': 0,
    'RefundAmount': 0,
    'Remark': '',
    'ThirdpartyPaymentOrderID': '',
    'ThirdpartyPaymentID': '',
    'SelectedOnlinePatientRegistrationID': 0,
    'SelectedClassID': 0,
    'BookingDate': "",
    'CheckinDate': "",
    'AdmissionDuration': 0,
    'TotalAmount': 0,
    'selectedRate': 0,
  };

  // // Function to calculate ages
  calculateAge(dob: string, currentD: string): { years: number, months: number, days: number } {
    const birthDate = new Date(dob);
    const currentDate = new Date(currentD);
    let years = currentDate.getFullYear() - birthDate.getFullYear();
    let months = currentDate.getMonth() - birthDate.getMonth();
    let days = currentDate.getDate() - birthDate.getDate();

    // Adjust if birth month/day hasn't passed yet this year
    if (days < 0) {
      months -= 1;
      const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }
    this.itemToEdit.Age = years + ' Y ' + months + ' M ' + days + ' D';
    return { years, months, days };
  }

  isUserWAGSM = true;
  // if check then GSM and WAGSM is same
  GetGSMasWAGSM(params, type) {
    if (type == 'Guest') {
      this.isUserWAGSM = !this.isUserWAGSM;
      if (params == true) {
        this.itemToEdit.WAGSM = this.itemToEdit.GSM;
      } else {
        this.itemToEdit.WAGSM = '';
      }
    }
  }

  IsUserEmailSend = false;
  IsEmailVerified = false;
  otp: string[] = new Array(4).fill('');
  EnteredOTP = '';
  ResendCount = 0;
  isResendDisabled: boolean = false;
  isResendUsed: boolean = false; // Track if resend has been used
  countdown: number = 60;
  timer: any;
  IsOTPSent = false;
  GuestOTP: string = "";
  // VerifyUserEmail is used to send a OTP into your mail to verify user Email.
  VerifyUserEmail(param) {
    if (this.itemToEdit.GuestEmail != undefined && this.itemToEdit.GuestEmail != null && this.itemToEdit.GuestEmail != '') {
      const Email = this.itemToEdit.GuestEmail;
      this.isInProgress = true;
      // this.UserEmail = email;
      this.otp = ['', '', '', '']; // Reset OTP input
      this.loginService.ForgetPassword(Email, "", param, this.itemToEdit.GSM).subscribe((data) => {
        if (data.toString().includes('successfully')) {
          this.IsOTPSent = true;
          this.IsUserEmailSend = true;
          if (this.ResendCount == 0) {
            this.toasterService.success(data.toString());
            this.startResendTimer();
          } else {
            this.toasterService.success("A new OTP has been sent to your email. The previous OTP is no longer valid.");
          }
        } else if (data.toString().includes('already been registered')) {
          this.IsOTPSent = false;
          this.toasterService.warning(data.toString());
        } else if (data.toString().includes('not registered')) {
          this.IsOTPSent = false;
          this.toasterService.warning(data.toString());
        }
        else {
          this.IsOTPSent = false;
          this.toasterService.error(data.toString());
        }
        this.isInProgress = false;
      });
    } else {
      this.toasterService.warning("Please Enter Email ID !!");
    }
  }
  // this function is used to verify OTP send on email id
  VerifyOTP(UserName, OTP, param) {
    if (UserName.trim() != "" && OTP.trim() != "") {
      this.loginService.verifyOtp(UserName, OTP, param).subscribe(data => {
        if (data != null && data != undefined) {
          if (data === 'OK') {
            this.IsEmailVerified = true;
            this.IsUserEmailSend = false;
            this.IsOTPSent = false;
            this.toasterService.success("Email ID verified successfully.");
          }
          else {
            this.toasterService.warning("" + data);
            this.IsEmailVerified = false;
            this.IsOTPSent = false;
          }
        }
      });
    }
    else {
      this.toasterService.warning("Email ID or OTP can't be blank.");
    }
  }

  startResendTimer() {
    this.isResendDisabled = true;
    this.countdown = 60;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isResendDisabled = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  // This function saves Booking
  SaveDonation(isPayment) {

    this.itemToEditPayment.SelectedOnlinePatientRegistrationID = this.OnlinePatientRegistrationID;
    this.itemToEditPayment.ReceiptBookID = this.donationReceiptBook;
    this.itemToEditPayment.Amount = this.DonationAmount;

    this.bookingLoginService.SaveBooking(this.itemToEditPayment).subscribe((data) => {
      if (data == "OK") {
        this.OnlinePatientRegistrationID = 0;
        this.isDonation = false;
        this.DonationAmount = 0;
        this.toasterService.success("Record Save Successfully!!");
        this.LoadGuest();
      }
      else {
        this.toasterService.error('Something went wrong');
      }
    });
  }

  // Getting Refresh Token
  GetRefreshToken(): void {
    this.authService.getRefreshToken().subscribe((data) => {
      if (data != null || data != "") {
        this.authService.setToken(data);
      } else {
        this.authService.logOut();
      }
    });
  }

  BookingHistory = [];
  items = [];
  // load Guest Detail data
  LoadGuest() {
    this.BookingHistory = [];
    // this.isBookingHistory = false;
    this.bookingLoginService.GuestDetail(0, true, this.globals.UserID).subscribe((data) => {
      if (data.length > 0) {
        this.items = data;
      }
    })
  }

  // Log Out User
  LogOut() {
    this.authService.logOut();
    this.globals.UserName = '';
    this.globals.UserID = 0;
    this.router.navigate(['/session/booking']);
  }

  GuestName = '';
  MobileNo = '';
  OnlinePatientRegistrationID = 0;
  DonationAmount = 0;
  isDonation = false;
  UserEmail = '';
  // Go to donation screen with doner details
  Makedonation(OnlinePatientRegistrationID) {
    this.Today = this.datePipe.transform(this.currentDate, 'dd-MMM-yyyy HH:mm:ss');
    const result = this.items.filter((ele) => ele["OnlinePatientRegistrationID"] === OnlinePatientRegistrationID);
    this.OnlinePatientRegistrationID = OnlinePatientRegistrationID;
    if (result[0]['MiddleName'] != '') {
      this.GuestName = result[0]['FirstName'] + ' ' + result[0]['MiddleName'] + ' ' + result[0]['LastName'];
    } else {
      this.GuestName = result[0]['FirstName'] + ' ' + result[0]['LastName'];
    }
    this.UserEmail = result[0]['Email'];
    this.MobileNo = result[0]['MobileNo'];
    this.isDonation = true;
  }

  // Cancel Donation Transaction
  CancelDonationPayment() {
    this.Today = this.datePipe.transform(this.currentDate, 'dd-MMM-yyyy HH:mm:ss');
    this.GuestName = '';
    this.OnlinePatientRegistrationID = 0;
    this.MobileNo = '';
    this.isDonation = false;
    this.UserEmail = '';
  }

  itemToEdit = {
    'OnlinePatientRegistrationID': '',
    'OnlineUserRegistrationID': 0,
    'UHID': 0,
    'Prefix': '',
    'FirstName': '',
    'MiddleName': '',
    'LastName': '',
    'OnlineUserName': '',
    'GSM': '',
    'UserGSM': '',
    'WAGSM': '',
    'Age': '',
    'City': '',
    'State': '',
    'Country': '',
    'District': '',
    'GuestEmail': '',
    'RelationWithUser': '',
    'MigratedToUHID': 0,
    'PreferredLanguage': '',
    'BlackListed': false,
    'DateOfBirth': '',
    'Gender': '',
    'Address': '',
    'Nationality': '',
    'AadharNo': '',
    'PassportNo': '',
    'PinCode': '',
    'LogValue': '',
    'UserName': '',
    'Activate': true,
  };


  // itemToEdit = {
  //   'UHID': 0,
  //   'Prefix': '',
  //   'OnlineUserName': '',
  //   'GSM': '',
  //   'UserGSM': '',
  //   'WAGSM': '',
  //   'Age': '',
  //   'City': '',
  //   'State': '',
  //   'Country': '',
  //   'District': '',
  //   'GuestEmail': '',
  //   'RelationWithUser': '',
  //   'MigratedToUHID': 0,
  //   'PreferredLanguage': '',
  //   'BlackListed': false,
  // };

  // Add new doner
  AddNew(content) {
    this.itemToEdit = {
      'OnlinePatientRegistrationID': '',
      'OnlineUserRegistrationID': 0,
      'UHID': 0,
      'Prefix': '',
      'FirstName': '',
      'MiddleName': '',
      'LastName': '',
      'OnlineUserName': '',
      'GSM': '',
      'UserGSM': '',
      'WAGSM': '',
      'Age': '',
      'City': '',
      'State': '',
      'Country': '',
      'District': '',
      'GuestEmail': '',
      'RelationWithUser': '',
      'MigratedToUHID': 0,
      'PreferredLanguage': '',
      'BlackListed': false,
      'DateOfBirth': this.datePipe.transform(this.Today, 'yyyy-MM-dd'),
      'Gender': '',
      'Address': '',
      'Nationality': '',
      'AadharNo': '',
      'PassportNo': '',
      'PinCode': '',
      'LogValue': '',
      'UserName': this.globals.UserName,
      'Activate': true,
    };
    this.GuestOTP = '';
    this.IsEmailVerified = false;
    this.IsUserEmailSend = false;
    this.isValidAadhaar = true;
    this.modalService.open(content, { backdrop: 'static', size: 'xl', centered: true, keyboard: false });
  }

  isInProgress = false;
  // Save Doner as Guest
  SaveDoner() {
    if (this.itemToEdit.FirstName != '' && this.itemToEdit.LastName != '' && this.itemToEdit.Gender != '' && this.itemToEdit.Address != '' &&
      ((this.itemToEdit.Nationality == 'Indian' && this.itemToEdit.AadharNo.length == 12 && this.isValidAadhaar) ||
        (this.itemToEdit.Nationality != 'Indian' && this.itemToEdit.PassportNo != ''))) {
      // Check DOB is Current Date or not
      if (this.itemToEdit.DateOfBirth != "" && this.itemToEdit.DateOfBirth != null && this.itemToEdit.DateOfBirth != this.Today) {

        this.itemToEdit.DateOfBirth = this.datePipe.transform(this.itemToEdit.DateOfBirth, 'yyyy-MM-dd');
        this.itemToEdit.OnlineUserRegistrationID = this.globals.UserID;
        this.isInProgress = false;
        this.itemToEdit.LogValue = ' ,OnlinePatientRegistrationID: ' + this.itemToEdit.OnlinePatientRegistrationID +
          ' ,OnlineUserRegistrationID: ' + this.itemToEdit.OnlineUserRegistrationID +
          ' ,FirstName: ' + this.itemToEdit.FirstName +
          ' ,MiddleName: ' + this.itemToEdit.MiddleName +
          ' ,LastName: ' + this.itemToEdit.LastName +
          ' ,DateOfBirth: ' + this.itemToEdit.DateOfBirth +
          ' ,Gender: ' + this.itemToEdit.Gender +
          ' ,Address: ' + this.itemToEdit.Address +
          ' ,PinCode: ' + this.itemToEdit.PinCode;
        this.bookingLoginService.SaveGuest(this.itemToEdit).subscribe((data) => {
          if (data != undefined && data.length > 0) {
            if (data == "Ok") {
              this.toasterService.success("Record Save Successfully!!");
              this.LoadGuest();
              // Saved Succesfully
              document.getElementById('btnClose').click(); // call close button
            }
            else if (data == "Failed" || data == "") {
              // Exception Occurred
              this.toasterService.error('Something went wrong');
            }
            this.isInProgress = false;
          }
        });
        this.isInProgress = false;
      } else {
        this.toasterService.warning("Please select date of birth !!");
      }
    } else {
      this.toasterService.warning("Please enter mandatory fields !!");
    }
  }

  // to set Aadhar or Passport Mandatory on Nationality
  SetMandatoryAadharandPassport() {
    const append = '<i class="text-danger"> *</i>';

    if (this.itemToEdit.Nationality === 'Indian') {
      // Remove * from Passport and add * to Aadhaar
      document.getElementById('lblPassportNo').innerHTML =
        document.getElementById('lblPassportNo').innerHTML.replace(append, '');

      if (!document.getElementById('lblAadharNo').innerHTML.includes(append)) {
        document.getElementById('lblAadharNo').innerHTML += append;
      }
    } else {
      this.isValidAadhaar = true;
      // Remove * from Aadhaar and add * to Passport
      document.getElementById('lblAadharNo').innerHTML =
        document.getElementById('lblAadharNo').innerHTML.replace(append, '');

      if (!document.getElementById('lblPassportNo').innerHTML.includes(append)) {
        document.getElementById('lblPassportNo').innerHTML += append;
      }
    }
  }

  // Converting Text into UpperCase
  UpperCase(str, fieldname) {
    const result = this.validateService.UpperCase(str);
    this.itemToEdit[fieldname] = result;
  }
  // trim the spaces from strings
  TrimName(str, fieldname) {
    const result = str.trim();
    this.itemToEdit[fieldname] = result;
  }

  isPaymentHistory = false;
  SelectedOnlinePatientRegistrationID = 0;

  GetPaymentHistory(OnlinePatientRegistrationID) {
    this.isPaymentHistory = true;
    this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
  }

  // Show Back button
  GetBack() {
    this.isPaymentHistory = false;
    this.isDonation = false;
  }

  isValidAadhaar = true;
  ValidateAadhaar(aadhaarNumber): boolean {
    if (aadhaarNumber.trim() === "") {
      this.isValidAadhaar = false;
      return false;
    }
    else {
      if (!/^[2-9]\d{11}$/.test(aadhaarNumber)) // checking if aadhaar number is 12 digits and should not start with 0 and 1
      {
        this.isValidAadhaar = false;
        return false;
      }
      //calling function to check VerhoeffAlgorithm
      this.isValidAadhaar = VerhoeffAlgorithm.validateVerhoeff(aadhaarNumber);
      return this.isValidAadhaar;
    }
  }
}


// This class is used to validate Aadhaar number using VerhoeffAlgorithm
class VerhoeffAlgorithm {
  // Multiplication Table (D)
  private static d: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
  ];

  // Permutation Table (P)
  private static p: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
  ];

  // Inverse Table
  private static inv: number[] = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

  /**
   * Validates an Aadhaar number using Verhoeff Algorithm.
   * @param num - The Aadhaar number to validate.
   * @returns true if valid, false otherwise.
   */
  public static validateVerhoeff(num: string): boolean {
    let c = 0;
    const myArray = this.stringToReversedIntArray(num);

    for (let i = 0; i < myArray.length; i++) {
      c = this.d[c][this.p[i % 8][myArray[i]]];
    }
    return c === 0;
  }

  /**
   * Converts a string into a reversed integer array.
   * @param num - The string to convert.
   * @returns A reversed integer array.
   */
  private static stringToReversedIntArray(num: string): number[] {
    const myArray: number[] = num.split('').map((digit) => parseInt(digit, 10));
    return this.reverse(myArray);
  }

  /**
   * Reverses an array of integers.
   * @param myArray - The array to reverse.
   * @returns The reversed array.
   */
  private static reverse(myArray: number[]): number[] {
    return myArray.reverse();
  }
}